var render = function () {
  var _vm$material;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', _vm._b({
    attrs: {
      "outlined": "",
      "rounded": ""
    }
  }, 'v-sheet', {
    loading: _vm.loading
  }, false), [_c('v-list-item', {
    staticClass: "py-2"
  }, [_c('v-list-item-avatar', {
    attrs: {
      "color": "grey lighten-3",
      "rounded": "",
      "size": "64"
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$material = _vm.material) === null || _vm$material === void 0 ? void 0 : _vm$material.photo
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-icon', {
          attrs: {
            "large": "",
            "color": "grey"
          }
        }, [_vm._v("mdi-image-broken-variant")])];
      },
      proxy: true
    }])
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.material.maker || "-") + " ")]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.material.code) + " ")])], 1), _vm.$scopedSlots['actions'] ? _c('v-list-item-action', [_vm._t("actions")], 2) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }